import { Route } from '@angular/router';
import { Login } from './login/login';
import { Callback } from './callback/callback';

export const routes: Route[] = [
  { path: '', component: Login },
  { path: 'callback', component: Callback },
  { path: '**', redirectTo: '' },
];
